import { Control, FieldValues, Path, useController } from "react-hook-form";

import { TimeInput, TimeInputProps } from "./TimeInput";

type Props<T extends FieldValues> = Omit<TimeInputProps, "value" | "onChange" | "onBlur"> & {
  name: Path<T>;
  control: Control<T>;
  required?: boolean;
  onChange?: (value: number) => void;
  onBlur?: (minutes: number) => void;
};

export const TimeInputController = <T extends FieldValues>({
  name,
  control,
  required,
  onChange,
  onBlur,
  ...props
}: Props<T>) => {
  const { field } = useController({ name, control, rules: { required } });

  return (
    <TimeInput
      {...props}
      required={required}
      value={field.value}
      onChange={(minutes) => {
        field.onChange(minutes);
        onChange?.(minutes);
      }}
      onBlur={(minutes) => {
        field.onChange(minutes);
        field.onBlur();
        onBlur?.(minutes);
      }}
    />
  );
};
